import _classCallCheck from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread"; //@ts-check

import React from 'react';
import { withStyles, createStyles } from '@material-ui/core/styles';
import withWidth, { isWidthDown } from '@material-ui/core/withWidth';
import Grid from '@material-ui/core/Grid';
import PaginationTile from './Tile';
import { compose } from 'redux';
import { fade } from '@material-ui/core/styles/colorManipulator';

var getVisiblePages = function getVisiblePages(_ref) {
  var page = _ref.page,
      count = _ref.count,
      itemsPerPage = _ref.itemsPerPage,
      parentWidth = _ref.parentWidth;
  var pageCount = Math.ceil(count / itemsPerPage) - 1;
  var previewPages = 5;
  if (isWidthDown('xs', parentWidth)) previewPages = 1;else if (isWidthDown('sm', parentWidth)) previewPages = 3;else if (isWidthDown('md', parentWidth)) previewPages = 4;
  var min = Math.max(page - previewPages, 0);
  var max = Math.min(page + previewPages, pageCount);
  var visiblePages = [];

  for (var pageIdx = min; pageIdx <= max; ++pageIdx) {
    visiblePages.push(pageIdx);
  }

  return visiblePages;
};
/** @type {import('react').CSSProperties} */


var commonTileProperties = {
  textAlign: 'center',
  marginTop: 9,
  height: 30,
  paddingLeft: 11,
  paddingRight: 11,
  borderRadius: 0,
  display: 'inline-block',
  userSelect: 'none',
  cursor: 'pointer'
};
export var styles = function styles(theme) {
  var _theme$getStyle = theme.getStyle('Data.Grid'),
      selectorColor = _theme$getStyle.selectorColor,
      selectorItemColor = _theme$getStyle.selectorItemColor;

  selectorColor = theme.getColor(selectorColor);
  selectorItemColor = theme.getColor(selectorItemColor);
  return createStyles({
    tile: _objectSpread({}, commonTileProperties, {
      userSelect: 'none',
      color: selectorItemColor,
      '&:hover': {
        backgroundColor: fade(selectorItemColor, 0.2)
      },
      '&:focus': {
        outlineColor: selectorItemColor
      }
    }),
    selectedTile: _objectSpread({}, commonTileProperties, {
      backgroundColor: selectorColor,
      color: 'white',
      cursor: 'initial'
    }),
    mainGrid: {
      paddingRight: 20,
      whiteSpace: 'nowrap',
      position: 'relative',
      top: -5,
      display: 'inline-block'
    },
    tileContent: {
      position: 'relative',
      top: 7
    },
    controlTile: _objectSpread({}, commonTileProperties, {
      color: selectorItemColor,
      '&:hover': {
        backgroundColor: fade(selectorItemColor, 0.2)
      },
      '&:focus': {
        outlineColor: selectorItemColor
      }
    })
  });
};
/**
 * @extends {React.Component<import('./types').DataGridViewPageSelectorProps & import('@material-ui/core').WithStyles & import('@material-ui/core/withWidth').WithWidth>}
 */

var PageSelector =
/*#__PURE__*/
function (_React$Component) {
  _inherits(PageSelector, _React$Component);

  function PageSelector() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, PageSelector);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(PageSelector)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.onChangePage = function (e, page) {
      _this.props.onChangePage(e, page);
    };

    _this.goToFirstPage = function (e) {
      _this.props.onChangePage(e, 0);
    };

    _this.goToLastPage = function (e) {
      var _this$props = _this.props,
          count = _this$props.count,
          itemsPerPage = _this$props.itemsPerPage;

      _this.props.onChangePage(e, Math.ceil(count / itemsPerPage) - 1);
    };

    _this.handleBackButtonClick = function (event) {
      _this.props.onChangePage(event, _this.props.page - 1);
    };

    _this.handleNextButtonClick = function (event) {
      _this.props.onChangePage(event, _this.props.page + 1);
    };

    return _this;
  }

  _createClass(PageSelector, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          classes = _this$props2.classes,
          page = _this$props2.page;
      var visiblePages = getVisiblePages(this.props);
      var _this$props3 = this.props,
          count = _this$props3.count,
          itemsPerPage = _this$props3.itemsPerPage;
      var pageCount = count / itemsPerPage;
      return pageCount < 1 || count === itemsPerPage ? null : React.createElement(Grid, {
        container: true,
        style: page > 0 ? {
          left: -11
        } : null,
        className: classes.mainGrid
      }, visiblePages[0] !== 0 ? React.createElement(PaginationTile, {
        onChangePage: this.goToFirstPage,
        styling: {
          grid: classes.controlTile,
          span: classes.tileContent
        }
      }, "First") : null, page === 0 ? null : React.createElement(PaginationTile, {
        onChangePage: this.handleBackButtonClick,
        styling: {
          grid: classes.controlTile,
          span: classes.tileContent
        }
      }, "Previous"), visiblePages.map(function (i) {
        return React.createElement(PaginationTile, {
          xs: true,
          key: i,
          page: i,
          onChangePage: _this2.onChangePage,
          styling: {
            grid: i === page ? classes.selectedTile : classes.tile,
            span: classes.tileContent
          }
        });
      }), page === visiblePages[visiblePages.length - 1] ? null : React.createElement(PaginationTile, {
        onChangePage: this.handleNextButtonClick,
        styling: {
          grid: classes.controlTile,
          span: classes.tileContent
        }
      }, "Next"), visiblePages[visiblePages.length - 1] !== Math.ceil(pageCount) - 1 ? React.createElement(PaginationTile, {
        onChangePage: this.goToLastPage,
        styling: {
          grid: classes.controlTile,
          span: classes.tileContent
        }
      }, "Last") : null);
    }
  }]);

  return PageSelector;
}(React.Component);

export default compose(withStyles(styles, {
  name: 'ECPageSelector'
}), withWidth())(PageSelector);